import React, { ReactNode, useEffect } from 'react';
import { useNotification } from 'hooks/use-notification';
import { useAuthStore } from './store/auth/useAuthStore';
// import { useNotificationStore } from './store/common/useNotificationStore';

export const NotificationMiddleware: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const { connect, disconnect } = useNotification();

  // Cleanup stops this connection (logout, unmount, StrictMode re-run), so always connect again here.
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    connect();
    return () => {
      disconnect.current?.();
    };
  }, [isAuthenticated]);

  return <>{children}</>;
};
